import { useEffect, useState } from "react";
import { getRemappingInfo } from "../../../../Account/utils/requestsTS";
export const useDeliveryScheduleRemappingModal = (orderId) => {
    const [orderData, setOrderData] = useState({
        orderInfo: null,
        blockingCopy: "",
        loading: true,
        error: "",
    });
    useEffect(() => {
        let mounted = true;
        if (mounted) {
            // If there is an orderId, get the remapping info for that order.
            if (orderId)
                getRemappingInfo(orderId, setOrderData);
        }
        return () => {
            mounted = false;
        };
    }, []);
    return { orderData };
};
